import { getStoredAuthUser } from "../../../public/utils/authSession";
import { decodeJwtPayload } from "../../../public/utils/jwtRole";
import { isUnrestrictedAdminRole } from "../../../public/utils/roleAccess";

/** Logged-in tbl_users.id for visitor list scoping (matches API `created_by`). */
export function getLoggedInStaffUserId() {
  const stored = getStoredAuthUser();
  if (stored?.id != null && Number.isFinite(Number(stored.id))) {
    return Number(stored.id);
  }
  if (typeof localStorage === "undefined") return null;
  const payload = decodeJwtPayload(localStorage.getItem("jwt_token"));
  const fromToken = payload?.tblUserId ?? payload?.tbl_user_id ?? payload?.id;
  if (fromToken != null && Number.isFinite(Number(fromToken))) {
    return Number(fromToken);
  }
  return null;
}

/**
 * Client-side list filter.
 * @param {"self"|"all"} listScope — staff screens (Visitors / Visitor register) use `self` even for admin.
 */
export function filterVisitorsForLoggedInUser(rows, roleSlug, listScope = "self") {
  const scope = listScope === "all" ? "all" : "self";
  if (scope === "all" && isUnrestrictedAdminRole(roleSlug)) {
    return Array.isArray(rows) ? rows : [];
  }
  const uid = getLoggedInStaffUserId();
  if (!uid) return [];
  return (Array.isArray(rows) ? rows : []).filter(
    (row) => Number(row?.created_by) === uid,
  );
}
